import {
  LOGIN_SUCCEEDED,
  LOGIN_FAILED,
  LOGOUT_SUCCEEDED,
  SET_PASSWD,
  SET_USERNAME,
  SET_CSFR_TOKEN,
  Actions,
  LOAD_API_TOKEN_SUCCEEDED,
  SET_EMAIL,
  SET_NEW_PASSWORD,
  SET_VERIFY_PASSWORD,
  SEND_VERIFY_PASSWORD_SUCCESS,
  SET_AUTH_LOADING,
  SEND_VERIFY_PASSWORD_FAILED,
  SEND_VERIFY_PASSWORD,
  UNSET_UPDATE_PASSWORD_SUCCESS,
  SEND_RECOVERY_EMAIL_FAILED,
  PROCEED_PASSWORD_FLOW,
  CLEAR_EMAIL,
  RESET_AUTH_FLOW,
} from './actions';
import { IAuthState } from './types';

const initialState: IAuthState = {
  username: '',
  password: '',
  showPasswordField: false,
  apiToken: null,
  csfrToken: null,
  email: '',
  newPassword: '',
  verifyPassword: '',
  loading: false,
  error: null,
};

const reducer = (state: IAuthState = initialState, action: Actions) => {
  switch (action.type) {
    case SEND_RECOVERY_EMAIL_FAILED:
      return {
        ...state,
        error: action.payload,
      };
    case SEND_VERIFY_PASSWORD:
    case UNSET_UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePasswordSuccess: undefined,
      };
    case SEND_VERIFY_PASSWORD_SUCCESS:
      return {
        ...state,
        newPassword: '',
        verifyPassword: '',
        updatePasswordSuccess: true,
      };
    case SEND_VERIFY_PASSWORD_FAILED:
      return {
        ...state,
        updatePasswordSuccess: false,
      };
    case SET_CSFR_TOKEN:
      return {
        ...state,
        csfrToken: action.payload.csfrToken,
      };
    case SET_USERNAME:
      return {
        ...state,
        username: action.payload.username,
      };
    case SET_PASSWD:
      return {
        ...state,
        password: action.payload.password,
      };
    case PROCEED_PASSWORD_FLOW:
      return {
        ...state,
        showPasswordField: true,
      };
    case RESET_AUTH_FLOW:
      return {
        ...state,
        showPasswordField: false,
        error: null,
        remainingLoginAttempts: undefined,
      };
    case LOGIN_SUCCEEDED:
      return {
        ...state,
        email: '',
        password: '',
        apiToken: action.payload.apiToken,
        error: null,
        remainingLoginAttempts: undefined,
      };
    case LOGIN_FAILED:
      return {
        ...state,
        apiToken: null,
        error: action.payload.error,
        remainingLoginAttempts: action.payload.remainingLoginAttempts,
      };
    case LOGOUT_SUCCEEDED:
      return {
        ...state,
        apiToken: null,
        error: null,
      };
    case LOAD_API_TOKEN_SUCCEEDED:
      return {
        ...state,
        apiToken: action.payload.apiToken,
      };
    case SET_EMAIL:
      return {
        ...state,
        email: action.payload.email,
      };
    case CLEAR_EMAIL:
      return {
        ...state,
        email: '',
        password: '',
      };
    case SET_NEW_PASSWORD:
      return {
        ...state,
        newPassword: action.payload.newPassword,
      };
    case SET_VERIFY_PASSWORD:
      return {
        ...state,
        verifyPassword: action.payload.verifyPassword,
      };
    case SET_AUTH_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default reducer;
